/**
 * Chat SMS to email class
 */
export default class {
  constructor (data) {
    this.enabled = data.enabled
    this.emails = data.emails
    this.did_id = data.did_id
  }
}
